import { useGcsStore } from '../../../store/useGcsStore';
import { type MissionId } from '../../../types/gcs/mission';
import { LaunchpadMarker } from './markers/LaunchpadMarker';

interface SingleMissionLaunchpadMarkerProps {
  gcsId: string;
  missionId: MissionId;
}

export const SingleMissionLaunchpadMarker = ({ gcsId, missionId }: SingleMissionLaunchpadMarkerProps) => {
  const launchpad = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    if (!gcsData) return null;

    const liveMission = Array.from(gcsData.liveMissionsMap.values()).find((mission) => mission.missionId === missionId);
    if (!liveMission) return null;

    const launchpadId = gcsData.vehicleLaunchpadMap.get(liveMission.vehicleId);
    if (launchpadId === undefined) return null;

    return (gcsData.launchpads.data ?? []).find((item) => item.id === launchpadId) ?? null;
  });

  if (!launchpad) {
    return null;
  }

  return <LaunchpadMarker gcsId={gcsId} launchpad={launchpad} />;
};
